
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import sizesDemo from './demo/sizes.twig';
import './demo/styles.scss';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Utilities/Rounded Corners" mdxType="Meta" />
    <h1>{`Rounded Corners`}</h1>
    <p>{`Utilities for controlling the `}<inlineCode parentName="p">{`border-radius`}</inlineCode>{` of an element.`}</p>
    <h2>{`Sizes`}</h2>
    <p><inlineCode parentName="p">{`u-rounded`}</inlineCode>{` applies the default rounded corner size, as seen in components like `}<a parentName="p" {...{
        "href": "/docs/components-button--elements"
      }}>{`Button`}</a>{` and `}<a parentName="p" {...{
        "href": "/docs/components-input--text-elements"
      }}>{`Input`}</a>{`.`}</p>
    <p><inlineCode parentName="p">{`u-rounded-full`}</inlineCode>{` applies as much rounding as possible evenly. This results in circular or pill-shaped elements.`}</p>
    <p><inlineCode parentName="p">{`u-rounded-none`}</inlineCode>{` omits rounded corners entirely.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Sizes" mdxType="Story">{sizesDemo()}</Story>
    </Canvas>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const sizes = () => (
          sizesDemo()
        );
sizes.storyName = 'Sizes';
sizes.parameters = { storySource: { source: 'sizesDemo()' } };

const componentMeta = { title: 'Utilities/Rounded Corners', includeStories: ["sizes"],  };

const mdxStoryNameToKey = {"Sizes":"sizes"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;